import {
  LocalStorageConsts,
} from 'client/util/Constants';
import LocalStorageService from 'client/util/LocalStorageService';
import moment from 'moment';
import store from 'client/store';

const { upgradeLoginNudgeLastDismissed } = LocalStorageConsts;

const returnFeatureUsage = (feature, storeInstance) => {
  const getFeatureUsage = storeInstance.getters['FeatureTrialModule/getFeatureUsage'];
  return getFeatureUsage(feature);
};

const returnUpgradeNudgeVisibility = (feature, storeInstance) => {
  const getUpgradeNudgeVisibility = storeInstance.getters['FeatureTrialModule/getUpgradeNudgeVisibility'];
  return getUpgradeNudgeVisibility(feature);
};

const returnAllActiveFeatureTrials = (storeInstance) => {
  const getAllActiveFeatureTrials = () => storeInstance.getters['FeatureTrialModule/getAllActiveFeatureTrials'];
  return getAllActiveFeatureTrials();
};

const getNudgeDataFromStorage = () => {
  const localStorageNudgeData = LocalStorageService.getItem(upgradeLoginNudgeLastDismissed);
  return localStorageNudgeData ? JSON.parse(localStorageNudgeData) : null;
};

const setNudgeDataToStorage = (nudgeConfig) => {
  LocalStorageService.setItem(upgradeLoginNudgeLastDismissed, JSON.stringify(nudgeConfig));
};

const setUpgradeLoginNudge = () => {
  const defaultLoginNudgeData = [];

  const currentNudgeData = getNudgeDataFromStorage();
  if (currentNudgeData === null) {
    setNudgeDataToStorage(defaultLoginNudgeData);
  }
};

const dismissUpgradeLoginNudge = (featureName) => {
  const currentUpgradeNudgeData = getNudgeDataFromStorage();
  const currentDateTimeStamp = moment().toISOString();

  // handle default empty state
  if (currentUpgradeNudgeData.length === 0) {
    currentUpgradeNudgeData.push({
      featureName,
      lastDateDismissed: currentDateTimeStamp,
    });
    setNudgeDataToStorage(currentUpgradeNudgeData);
    return;
  }
  // handle non-default state
  const indexOfLoggedDismissal = currentUpgradeNudgeData
    .findIndex(feature => feature.featureName === featureName);
  if (indexOfLoggedDismissal >= 0) {
    currentUpgradeNudgeData[indexOfLoggedDismissal].featureName = featureName;
    currentUpgradeNudgeData[indexOfLoggedDismissal].lastDateDismissed = currentDateTimeStamp;
  } else {
    currentUpgradeNudgeData.push({
      featureName,
      lastDateDismissed: currentDateTimeStamp,
    });
  }
  setNudgeDataToStorage(currentUpgradeNudgeData);
};

const dateIsWithin15Days = (feature) => {
  const currentDate = moment();
  const dateDiff = currentDate.diff(moment(feature.lastDateDismissed), 'days');
  return dateDiff > 15;
};

const hasBeenDismissed = (featureName) => {
  const upgradeLoginNudgeData = getNudgeDataFromStorage();

  // Check first if feature has been logged in local storage and if not, return true
  const doesFeatureExist = upgradeLoginNudgeData
    .findIndex(feature => feature.featureName === featureName);

  if (doesFeatureExist === -1) return true;

  // For features that have been logged, remove any that have been dismissed in last 15 days
  const featureInStorage = upgradeLoginNudgeData
    .filter(feature => featureName === feature.featureName && dateIsWithin15Days(feature));

  return featureInStorage.length > 0;
};

const getAvailableUpgradeLogins = (storeInstance = store) => {
  // get all active feature trials
  const allActiveFeatureTrials = returnAllActiveFeatureTrials(storeInstance);

  // remove any active feature trials running < 30 days
  const activeTrials30DaysOrOlder = allActiveFeatureTrials
    .filter((feature) => returnUpgradeNudgeVisibility(feature, storeInstance));

  // return array with name and number of days the trial has been running
  const featureNudges = activeTrials30DaysOrOlder.map(feature => {
    const featureInfo = returnFeatureUsage(feature, storeInstance);
    const featureWasDismissed = hasBeenDismissed(feature);

    let featureNudge;
    // has this feature nudge been dismissed in last 15 days?
    if (featureWasDismissed) {
      const currentDate = moment();
      const dayDifference = currentDate.diff(moment(featureInfo.startDate), 'days');
      featureNudge = {
        featureName: feature,
        featureDayCount: dayDifference + 1,
      };
    }
    return featureNudge || null;
  }).filter(nudge => nudge !== null);

  return featureNudges;
};

export default {
  dismissUpgradeLoginNudge,
  getAvailableUpgradeLogins,
  setUpgradeLoginNudge,
};
